
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'How the service works',
    intro:
      'SHOT is a platform where you top up an internal balance, use it to interact with digital content, and receive digital items inside the service.',
    step1Title: 'Topping up the balance',
    step1Text:
      'To start using the service, you top up your internal SHOT balance via the payment methods available on the site.',
    step2Title: 'Using the balance inside the platform',
    step2Text:
      "The topped-up balance is used only inside SHOT. With it you get access to the platform's features and the digital content available in the service.",
    step3Title: 'Opening cases',
    step3Text:
      'After topping up, you can choose and open cases available on the platform. Each case contains digital items that can be obtained by opening it.',
    step4Title: 'Receiving a digital item',
    step4Text:
      'After opening a case, you receive a digital item inside the SHOT platform. The received item is shown in the service interface and becomes available for further actions within the provided functionality.',
    step5Title: 'Further actions with the item',
    step5Intro: "Depending on the platform's available options, you can:",
    step5Item1: 'keep the item inside SHOT;',
    step5Item2: 'sell the item inside SHOT for internal balance;',
    step5Item3:
      'withdraw the item to your own Steam account, if this option is available for the specific item.',
    step6Title: 'Important note',
    step6Text:
      "All main user actions happen inside the SHOT platform through the site interface. The terms of use of the internal balance, digital content, and item withdrawal are determined by the service's rules and functional capabilities.",
  },
  ru: {
    title: 'Как работает сервис',
    intro:
      'SHOT — это платформа, внутри которой пользователь пополняет внутренний баланс, использует его для взаимодействия с цифровым контентом и получает цифровые предметы внутри сервиса.',
    step1Title: 'Пополнение баланса',
    step1Text:
      'Чтобы начать пользоваться сервисом, пользователь пополняет внутренний баланс SHOT через доступные способы оплаты на сайте.',
    step2Title: 'Использование баланса внутри платформы',
    step2Text:
      'Пополненный баланс используется только внутри SHOT. С его помощью пользователь получает доступ к функциям платформы и цифровому контенту, представленному в сервисе.',
    step3Title: 'Открытие кейсов',
    step3Text:
      'После пополнения баланса пользователь может выбирать и открывать кейсы, доступные на платформе. В каждом кейсе представлены цифровые предметы, которые могут быть получены в результате открытия.',
    step4Title: 'Получение цифрового предмета',
    step4Text:
      'После открытия кейса пользователь получает цифровой предмет внутри платформы SHOT. Полученный предмет отображается в интерфейсе сервиса и становится доступен для дальнейших действий в рамках предусмотренного функционала.',
    step5Title: 'Дальнейшие действия с предметом',
    step5Intro: 'В зависимости от доступных возможностей платформы пользователь может:',
    step5Item1: 'оставить предмет внутри SHOT;',
    step5Item2: 'реализовать предмет внутри SHOT за внутренний баланс;',
    step5Item3:
      'вывести предмет на собственный аккаунт Steam, если для конкретного предмета такая возможность доступна.',
    step6Title: 'Важное уточнение',
    step6Text:
      'Все основные действия пользователя происходят внутри платформы SHOT через интерфейс сайта. Условия использования внутреннего баланса, цифрового контента и вывода предметов определяются правилами и функциональными возможностями сервиса.',
  },
  uz: {
    title: 'Xizmat qanday ishlaydi',
    intro:
      'SHOT — bu platforma boʻlib, unda foydalanuvchi ichki balansni toʻldiradi, undan raqamli kontent bilan ishlash uchun foydalanadi va servis ichida raqamli buyumlar oladi.',
    step1Title: 'Balansni toʻldirish',
    step1Text:
      'Xizmatdan foydalanishni boshlash uchun foydalanuvchi saytdagi mavjud toʻlov usullari orqali SHOT ichki balansini toʻldiradi.',
    step2Title: 'Balansdan platforma ichida foydalanish',
    step2Text:
      'Toʻldirilgan balans faqat SHOT ichida ishlatiladi. Uning yordamida foydalanuvchi platforma funksiyalari va servisdagi raqamli kontentga kirish huquqini oladi.',
    step3Title: 'Keyslarni ochish',
    step3Text:
      'Balansni toʻldirgach, foydalanuvchi platformada mavjud keyslarni tanlashi va ochishi mumkin. Har bir keysda ochish natijasida olinishi mumkin boʻlgan raqamli buyumlar mavjud.',
    step4Title: 'Raqamli buyum olish',
    step4Text:
      'Keys ochilgach, foydalanuvchi SHOT platformasi ichida raqamli buyum oladi. Olingan buyum servis interfeysida koʻrsatiladi va koʻzda tutilgan funksional doirasida keyingi harakatlar uchun mavjud boʻladi.',
    step5Title: 'Buyum bilan keyingi harakatlar',
    step5Intro: 'Platformaning mavjud imkoniyatlariga qarab foydalanuvchi:',
    step5Item1: 'buyumni SHOT ichida qoldirishi;',
    step5Item2: 'buyumni SHOT ichida ichki balansga sotishi;',
    step5Item3:
      'agar aniq buyum uchun bunday imkoniyat mavjud boʻlsa, buyumni oʻzining Steam akkauntiga chiqarishi mumkin.',
    step6Title: 'Muhim izoh',
    step6Text:
      'Foydalanuvchining barcha asosiy harakatlari sayt interfeysi orqali SHOT platformasi ichida sodir boʻladi. Ichki balans, raqamli kontent va buyumlarni chiqarish shartlari servis qoidalari va funksional imkoniyatlari bilan belgilanadi.',
  },
  fa: {
    title: 'سرویس چطور کار می‌کند',
    intro:
      'SHOT پلتفرمی است که در آن موجودی داخلی را شارژ می‌کنی، با آن با محتوای دیجیتال کار می‌کنی و داخل سرویس آیتم دیجیتال می‌گیری.',
    step1Title: 'شارژ موجودی',
    step1Text:
      'برای شروع کار با سرویس، موجودی داخلی SHOT را با روش‌های پرداختی که در سایت هست شارژ می‌کنی.',
    step2Title: 'استفاده از موجودی داخل پلتفرم',
    step2Text:
      'موجودی شارژشده فقط داخل SHOT خرج می‌شود. با آن به امکانات پلتفرم و محتوای دیجیتال موجود در سرویس دسترسی پیدا می‌کنی.',
    step3Title: 'باز کردن کیس',
    step3Text:
      'بعد از شارژ می‌توانی کیس‌های موجود در پلتفرم را انتخاب و باز کنی. هر کیس آیتم‌های دیجیتالی دارد که با باز کردن به دست می‌آیند.',
    step4Title: 'دریافت آیتم دیجیتال',
    step4Text:
      'بعد از باز کردن کیس، آیتم دیجیتال را داخل پلتفرم SHOT می‌گیری. آیتم در رابط سرویس نشان داده می‌شود و برای کارهای بعدی در حد امکانات موجود در دسترس است.',
    step5Title: 'کارهای بعدی با آیتم',
    step5Intro: 'بسته به گزینه‌های موجود در پلتفرم می‌توانی:',
    step5Item1: 'آیتم را داخل SHOT نگه داری؛',
    step5Item2: 'آیتم را داخل SHOT بفروشی و موجودی داخلی بگیری؛',
    step5Item3: 'اگر برای آن آیتم ممکن باشد، آن را به حساب استیم خودت برداشت کنی.',
    step6Title: 'نکته مهم',
    step6Text:
      'همه کارهای اصلی کاربر داخل پلتفرم SHOT و از طریق رابط سایت انجام می‌شود. شرایط استفاده از موجودی داخلی، محتوای دیجیتال و برداشت آیتم را قوانین و امکانات سرویس تعیین می‌کنند.',
  },
  pt: {
    title: 'Como o serviço funciona',
    intro:
      'O SHOT é uma plataforma em que o usuário deposita em um saldo interno, usa esse saldo para interagir com conteúdo digital e recebe itens digitais dentro do serviço.',
    step1Title: 'Depósito no saldo',
    step1Text:
      'Para começar a usar o serviço, o usuário deposita no saldo interno do SHOT pelas formas de pagamento disponíveis no site.',
    step2Title: 'Uso do saldo dentro da plataforma',
    step2Text:
      'O saldo depositado é usado só dentro do SHOT. Com ele, o usuário tem acesso às funções da plataforma e ao conteúdo digital oferecido no serviço.',
    step3Title: 'Abertura de caixas',
    step3Text:
      'Depois de depositar, o usuário pode escolher e abrir as caixas disponíveis na plataforma. Cada caixa contém itens digitais que podem ser obtidos ao abri-la.',
    step4Title: 'Recebimento do item digital',
    step4Text:
      'Depois de abrir a caixa, o usuário recebe um item digital dentro da plataforma SHOT. O item recebido aparece na interface do serviço e fica disponível para outras ações dentro das funções previstas.',
    step5Title: 'Outras ações com o item',
    step5Intro: 'Dependendo das opções disponíveis na plataforma, o usuário pode:',
    step5Item1: 'manter o item dentro do SHOT;',
    step5Item2: 'vender o item dentro do SHOT por saldo interno;',
    step5Item3:
      'sacar o item para a própria conta Steam, se essa opção estiver disponível para o item em questão.',
    step6Title: 'Observação importante',
    step6Text:
      'Todas as ações principais do usuário acontecem dentro da plataforma SHOT pela interface do site. As condições de uso do saldo interno, do conteúdo digital e do saque de itens são definidas pelas regras e pelas funcionalidades do serviço.',
  },
  tr: {
    title: 'Servis nasıl çalışır',
    intro:
      'SHOT, kullanıcının iç bakiyesine para yüklediği, bu bakiyeyle dijital içerikle etkileşime girdiği ve servis içinde dijital eşyalar aldığı bir platformdur.',
    step1Title: 'Bakiye yükleme',
    step1Text:
      'Servisi kullanmaya başlamak için kullanıcı, sitedeki mevcut ödeme yöntemleriyle SHOT iç bakiyesine para yükler.',
    step2Title: 'Bakiyenin platform içinde kullanımı',
    step2Text:
      'Yüklenen bakiye yalnızca SHOT içinde kullanılır. Kullanıcı bu bakiyeyle platformun özelliklerine ve serviste sunulan dijital içeriğe erişir.',
    step3Title: 'Kasa açma',
    step3Text:
      'Bakiye yükledikten sonra kullanıcı, platformdaki mevcut kasaları seçip açabilir. Her kasada, açılış sonucunda elde edilebilecek dijital eşyalar bulunur.',
    step4Title: 'Dijital eşyanın alınması',
    step4Text:
      'Kasa açıldıktan sonra kullanıcı, SHOT platformu içinde bir dijital eşya alır. Alınan eşya servis arayüzünde görünür ve sunulan işlevler kapsamında sonraki işlemler için kullanılabilir hale gelir.',
    step5Title: 'Eşyayla yapılabilecek sonraki işlemler',
    step5Intro: 'Platformun mevcut olanaklarına bağlı olarak kullanıcı:',
    step5Item1: 'eşyayı SHOT içinde tutabilir;',
    step5Item2: 'eşyayı SHOT içinde iç bakiye karşılığında satabilir;',
    step5Item3:
      'söz konusu eşya için bu seçenek mevcutsa eşyayı kendi Steam hesabına çekebilir.',
    step6Title: 'Önemli not',
    step6Text:
      'Kullanıcının tüm temel işlemleri SHOT platformu içinde, site arayüzü üzerinden gerçekleşir. İç bakiyenin, dijital içeriğin ve eşya çekiminin kullanım koşulları servisin kuralları ve işlevsel olanaklarıyla belirlenir.',
  },
});
